import { getCookie } from "../../utils";

/**
 * Navigate by submitting a hidden form, instead of putting the data in a URL.
 *
 * The MS Teams SSO flow carries an Entra JWT of roughly 2.2 KB. In a query string that pushes
 * the URL past the 2048-character cap some managed browsers and corporate proxies enforce, and
 * the truncation is silent: header and payload arrive intact while the RS256 signature is cut
 * short, so the server rejects a token that was never malformed (BRA-895). A request body has
 * no equivalent limit.
 *
 * `target` names the window to submit into; omit it to navigate the current one. A named target
 * must already exist — open it before calling, or the browser chooses where to put the response.
 */
export function submitFormNavigation(action: string, fields: Record<string, string>, target?: string): void {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = action;
    if (target) {
        form.target = target;
    }

    const payload: Record<string, string> = { ...fields, csrfmiddlewaretoken: getCookie("csrftoken") ?? "" };
    for (const [name, value] of Object.entries(payload)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    form.remove();
}
